"use client";
// РУКА 2. «Корзина» в шапке — со счётчиком позиций, когда в корзине что-то есть.
// Вид — из макета: значок, кружок-счётчик, подпись.
import Link from "next/link";
import { useCart } from "./cart";
import { Icon } from "./look/icons";

export function CartLink() {
  const n = useCart().reduce((s, l) => s + l.qty, 0);
  // Вид — как в макете (Р-020): значок с кружком-счётчиком, под ним подпись
  return (
    <Link href="/cart" className="hbx" data-v="cart" aria-label={n ? `Корзина, позиций: ${n}` : "Корзина"}>
      <span className="hbi">
        <Icon name="cart" />
        <span className={`n ${n ? "" : "z"}`}>{n > 99 ? "99+" : n}</span>
      </span>
      <span className="t">Корзина</span>
    </Link>
  );
}
